import apiClient from '../utilities/apiClient.utility';

const programsUrl = `${window.config.CONNECT_URLS.programs}`;

export const getProgramsList = async () => {
    console.log("Programs URL", programsUrl);
  const result  = await apiClient.get(
    `${programsUrl}/private/config`
  );
  return result;
  
};